
// Fire custom event cross-browser
export default function fireCustomEvent (name = '', detail = {}, bubbles = false, cancelable = false, from = window) {
  if (!name) {
    return
  }

  from.dispatchEvent(new CustomEvent(name, { bubbles: bubbles, cancelable: cancelable, detail: detail }))
}
